import purchaseAdditionalCreditsFeatures from './PurchaseAddtionalCredits';
import creditsUsedFeatures from './CreditsUsed';

const creditsFeatures = ({
  packages,
  activePackages,
  canUseVouchers,
  totalVoucher,
}) => ({
  purchaseAdditionalCredits: {
    key: 'purchase-additional-credits',
    label: 'purchaseAdditionalCredits',
    values: purchaseAdditionalCreditsFeatures({ packages, activePackages }),
  },
  creditsUsed: {
    key: 'credits-used',
    label: 'creditsUsed',
    values: creditsUsedFeatures({
      packages,
      activePackages,
      canUseVouchers,
      totalVoucher,
    }),
    tooltipContent: 'creditsTooltipForAPIUsage',
  },
});

export default creditsFeatures;
